import merge from 'lodash/merge';

export const getAppConfig = () => {
	const defaultValue = {
		individualSpreadsheet: {},
		pedigreeSpreadsheet: {},
		userMaintenance: {},
		individuals: {}
	};

  	return window.progenyWebConfig || defaultValue;
};

export const setAppConfig = (config) => {
	const currentConfig = getAppConfig();
	window.progenyWebConfig = merge(currentConfig, config);
};